/**
 * Details section layout adjustments
**/

export function initDetailsLayout() {
    document.addEventListener('DOMContentLoaded', () => {
        function applyShift() {
            const items = document.querySelectorAll('.c-details__specs-item');

            // Limpia estilos por si el usuario redimensiona
            items.forEach(item => {
                // Excluir el elemento con id "reparto"
                if (item.id !== 'reparto') {
                    item.style.position = '';
                    item.style.bottom = '';
                }
            });

            // Solo aplica si >= 1024px
            if (window.matchMedia('(min-width: 1024px)').matches) {
                items.forEach((item, index) => {
                    // Excluir el elemento con id "reparto" del ajuste
                    if (index >= 7 && item.id !== 'reparto') { // noveno item (índice 8)
                        item.style.position = 'relative';
                        item.style.bottom = '39px';
                    }
                });
            }
        }

        // Primera ejecución
        applyShift();

        // Si el usuario redimensiona, se vuelve a calcular
        window.addEventListener('resize', applyShift);
    });
}

